module.exports = __webpack_public_path__ + "img/20180128143953.90dea300.jpg";